import sanitizeHTML from "@app/utils/sanitizeHTML";
import cx from "classnames";

import styles from "./table.module.css";

type TableBodyProps = {
  bodyData: string[][];
  hasColHeader: boolean | undefined;
  useHTML?: boolean;
  additionalAllowedTags?: string[];
};

const TableBody = ({
  bodyData,
  hasColHeader,
  useHTML,
  additionalAllowedTags,
}: TableBodyProps) => {
  return (
    <tbody>
      {bodyData.map((row, rowIndex) => (
        <tr key={rowIndex} className={styles.tableBodyRow}>
          {row.map((cell, colIndex) => {
            // Using th tag for column headings
            const TableHTMLTag = hasColHeader && colIndex === 0 ? "th" : "td";
            return (
              <TableHTMLTag
                key={colIndex}
                className={cx(
                  styles.cellStyles,
                  TableHTMLTag === "th" && styles.fontBold,
                )}
              >
                {useHTML ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: sanitizeHTML(cell, additionalAllowedTags),
                    }}
                  />
                ) : (
                  cell
                )}
              </TableHTMLTag>
            );
          })}
        </tr>
      ))}
    </tbody>
  );
};

export default TableBody;
